import axios from 'axios'
import { Loading } from 'element-ui'

let loading
const startLoading = () => {
    loading = Loading.service({
        lock: true,
        target: 'body'
    });
};
const endLoading = () => {
    loading.close();
};
export default {
    Request: function (cur) {
        startLoading()
        let reqParam = []
        let bindsElm = []
        //当前组件
        if (cur.reqParam) {
            cur.reqParam.forEach(element => {
                reqParam.push(element)
            });
        }
        if (cur.BindCallBackData) {
            bindsElm.push(cur)
        }
        //子组件
        cur.$children.forEach(element => {
            if (element.reqParam) {
                element.reqParam.forEach(p => {
                    reqParam.push(p)
                })
            }
            if (element.BindCallBackData) {
                bindsElm.push(element)
            }
        });
        if (reqParam.length > 0) {
            axios.post(`/APIFactory/`, reqParam)
                .then(res => {
                    if (res.data.ErrorCode == 0) {
                        bindsElm.forEach(element => {
                            element.BindCallBackData(res)
                        });
                    } else if (res.data.ErrorCode == 1) {
                        console.log(res.data.ErrorMsg)
                    }
                }).catch(err => {
                    console.log(err)
                })
                .finally(rel => {
                    endLoading()
                })
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/request.js